<template>
  <section>
    <form method="post" @submit.prevent="onSend" novalidate>
      <div class="modal-card" style="width: 1000px; min-height: 400px">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            指定群組
          </p>
        </header>

        <section class="modal-card-body">
          <form-group>
            <b-taginput
              v-model="EmployeeGroups"
              :loading="isLoading"
              :data="filteredGroups"
              autocomplete
              open-on-focus
              field="title"
              placeholder="輸入群組名稱來找尋"
              :allow-duplicates="false"
              @typing="filterGroups"
            >
              <template v-slot="props">
                <p
                  :class="
                    props.option.status
                      ? 'has-text-weight-semibold'
                      : 'has-text-grey-light'
                  "
                >
                  {{ props.option.title }}
                </p>
              </template>
              <template #empty>
                未選擇
              </template>
            </b-taginput>
          </form-group>
        </section>

        <footer class="modal-card-foot">
          <b-button
            :loading="isLoading"
            class="is-fullwidth"
            @click="$parent.close()"
          >
            {{ $t('attributes.close') }}
          </b-button>
          <b-button
            :loading="isLoading"
            type="is-primary"
            class="is-fullwidth"
            native-type="submit"
          >
            {{ $t('attributes.update') }}
          </b-button>
        </footer>

        <b-loading
          :active.sync="isLoading"
          :is-full-page="false"
          :can-cancel="false"
        ></b-loading>
      </div>
    </form>
  </section>
</template>

<script>
import { PERMISSION_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import debounce from 'lodash/debounce'

export default {
  name: 'EmployeeGroupsForm',

  props: {
    employee: {
      type: Object,
      required: true
    },
    sending: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      groups: [],
      filteredGroups: [],

      EmployeeGroups: []
    }
  },
  computed: {
    isLoading() {
      return this.loading || this.sending
    }
  },
  mounted() {
    this.fetchGroups()
  },
  methods: {
    async fetchGroups() {
      try {
        const api = `${PERMISSION_GROUPS_API}/list`

        this.loading = true
        const res = await this.axios.get(api)
        this.groups = res.data.data
        this.filteredGroups = [...this.groups]
        this.setupGroupEmployeesList()
      } catch (e) {
        this.groups = []
        this.filteredGroups = []
        this.EmployeeGroups = []

        notifyService.fetch_error('employee', e)
      } finally {
        this.loading = false
      }
    },
    setupGroupEmployeesList() {
      const groups = this.employee.permission_groups.map(e => e.id)

      this.EmployeeGroups = this.groups
        .filter(e => groups.includes(e.id))
        .sort(e => e.id)
        .sort((e1, e2) => e2.status - e1.status)
    },
    filterGroups: debounce(function(search) {
      this.filteringEmployeesAsync(search)
    }, 1000),
    async filteringEmployeesAsync(search) {
      if (!search) {
        this.filteredGroups = [...this.groups]
        return
      }

      this.filteredGroups = this.groups.filter(e => e.title.includes(search))
    },
    async onSend() {
      const groups = this.EmployeeGroups.sort(e => e.id)
        .sort((e1, e2) => e2.status - e1.status)
        .map(e => e.id)

      this.$emit('onSend', this.employee.emp_code, { groups })
    }
  }
}
</script>
